import { useEffect, useState } from "react";
import { getCompanies } from "../api/companyService";

export const useCompanies = (trigger) => {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCompanies()
        .then(setCompanies)
        .finally(() => setLoading(false));
    }, [trigger]);

    return { companies, loading, setCompanies };
};
